app.component("personalCalendar", {
	templateUrl: "app/src/js/components/personalCalendar/personalCalendar.html",
	controller: "personalCalendarController",
	bindings: {
		userId: "=",
		practiceId: "=",
		involvedPractices: "=",
		appointmentCategories: "=",
		availableEvents: "=",
		unavailableEvents: "=",
		refetch: "&",
		changeDateRange: "&",
		startDate: "=",
		clinicianName: "<",
		practiceName: "<",
	},
});

app.controller("ModalCtrl", [
	"$scope",
	function ($scope) {
		$scope.shouldDisableTimeslot = false;

		// 2. Check if the event spans multiple days
		let isMultiDay = false;
		if ($scope.availability && $scope.availability.ranges && $scope.availability.ranges.length > 0) {
			const start = $scope.availability.ranges[0].start;
			const end = $scope.availability.ranges[0].end;
			isMultiDay = moment(end).diff(moment(start), "hours") > 24;
		}

		// 3. Safely assign the radio button states based on actual duration
		if (!$scope.availability.availabilityId) {
			$scope.isDateRange.value = $scope.availability.isAllDay;
		} else if (parseInt($scope.availability.week_number_recurrence ?? 0) === 0) {
			// If it's a multi-day vacation, it MUST be a Date Range.
			// Otherwise, let it be an hourly or 1-day Time Slot!
			$scope.isDateRange.value = isMultiDay;
		} else {
			$scope.isDateRange.value = !parseInt($scope.availability.week_number_recurrence);
		}

		const validateTime = (start, end) => {
			// Compare Date objects directly
			const end_hour = end.getHours();
			const end_minute = end.getMinutes();

			const _end = new Date(start);
			_end.setHours(end_hour);
			_end.setMinutes(end_minute);
			_end.setSeconds(0);
			_end.setMilliseconds(0);
			var isValid = _end > start;

			$scope.availabilityForm?.end?.$setValidity("invalidTimeRange", isValid);
		};

		// Keep the parent 'availability' object in sync with the radio buttons
		$scope.$watch('isDateRange.value', function (n) {
			$scope.availability._isDateRange = n;
		});

		$scope.$watchGroup(["availability.start_time", "availability.end_time"], function (values) {
			var start = values[0];
			var end = values[1];

			if (!$scope.availabilityForm) {
				return;
			}

			if (!$scope.availabilityForm.end) {
				return;
			}

			if (!start || !end) {
				// Clear error if either is empty
				$scope.availabilityForm.end.$setValidity("invalidTimeRange", true);
				return;
			}

			validateTime(start, end);
		});

		$scope.$watch(
			"isDateRange",
			function (newValue, oldValue) {
				if (newValue.value) {
					let startDate, endDate;

					if ($scope.availability.ranges && $scope.availability.ranges.length > 0) {
						// 1. Existing events: Always clone to avoid mutating the original data
						// Always convert to local to avoid UTC "yesterday" shifts
						startDate = $scope.availability.ranges[0].start.clone().local();
						endDate = $scope.availability.ranges[0].end.clone().local();

						// If it's a full-day date range, the BE 'end' is usually the 
						// start of the NEXT day (exclusive). We subtract 1 day for the picker UI.
						if ($scope.availability.isAllDay || $scope.availability.recurrence_type === 'ONE_OFF') {
							endDate.subtract(1, "day");
						}
					} else {
						// 2. New events or converting an hourly slot: Fallback to the clicked date
						const fallbackDate = $scope.availability.dateStr
							? moment($scope.availability.dateStr.split("T")[0])
							: moment();

						startDate = fallbackDate.clone();
						// A selection across several days on the calendar carries its last day.
						endDate = $scope.availability.rangeEndStr ? moment($scope.availability.rangeEndStr) : fallbackDate.clone();
					}

					setTimeout(() => {
						$('input[name="daterange"]').daterangepicker({
							opens: "left",
							startDate: startDate,
							endDate: endDate,
							locale: { format: "DD/MMM/YYYY" },
						});
					}, 50);
				}
			},
			true
		);

		$scope.$watch(
			"availability.isAllDay",
			function (newValue, oldValue) {
				if (newValue === false) {
					const s = $scope.availability.start_time;
					const e = $scope.availability.end_time;

					// Safely handle both Strings and Date objects
					const isStartMidnight = (typeof s === 'string' && s.startsWith("00:00")) ||
						(s instanceof Date && s.getHours() === 0 && s.getMinutes() === 0);
					const isEndMidnight = (typeof e === 'string' && (e.startsWith("24:00") || e.startsWith("00:00"))) ||
						(e instanceof Date && e.getHours() === 0 && e.getMinutes() === 0);

					if (isStartMidnight && isEndMidnight) {
						// Existing events are opened from eventClick, which has no dateStr - only the time
						// of day is used from these, so fall back to today rather than an Invalid Date.
						const baseDate = $scope.availability.dateStr ? $scope.availability.dateStr : new Date();
						const newS = new Date(baseDate);
						const newE = new Date(baseDate);
						newS.setHours(9, 0, 0, 0);
						newE.setHours(10, 0, 0, 0);
						$scope.availability.start_time = newS;
						$scope.availability.end_time = newE;
					}

					setTimeout(() => {
						validateTime($scope.availability.start_time, $scope.availability.end_time);
					}, 500);
				}
			},
			true,
		);
	},
]);

app.controller("personalCalendarController", [
	"$scope",
	"AppointmentAPI",
	"$modal",
	"$filter",
	function ($scope, AppointmentAPI, $modal, $filter) {
		var calendarInstance;
		// The one event source holding the availability drawn on the calendar, replaced on every change.
		var availabilitySource;
		$scope.isDateRange = { value: false };
		$scope.AppointmentAPI = AppointmentAPI;
		// Shared with the editor's scope (a child of this one), so it is an object rather than a flag.
		$scope.deleteState = { open: false, mode: "all", options: [] };

		$scope.VIEW_MODES = [
			{ key: "timeGridDay", label: "Day" },
			{ key: "timeGridWeek", label: "Week" },
			{ key: "dayGridMonth", label: "Month" },
		];
		$scope.view = { mode: "timeGridWeek", title: "" };

		// 'prev', 'next' or 'today'
		$scope.navigate = function (action) {
			if (calendarInstance) {
				calendarInstance[action]();
			}
		};

		$scope.setViewMode = function (mode) {
			$scope.view.mode = mode;
			if (calendarInstance) {
				calendarInstance.changeView(mode);
			}
		};

		$scope.goToDate = function (date) {
			if (calendarInstance) {
				calendarInstance.gotoDate(date);
			}
		};

		$scope.$watchGroup(["$ctrl.availableEvents", "$ctrl.unavailableEvents"], function (newVal, oldVal) {
			const availableEvents = newVal[0] ?? [];
			const unavailableEvents = newVal[1] ?? [];

			const events = [...availableEvents, ...unavailableEvents];

			buildOverview(availableEvents, unavailableEvents);

			if (!calendarInstance) return;

			// Remove the previous source as a whole. getEvents() only returns events with an occurrence
			// in the visible range, so removing those one by one left every entry outside it behind,
			// and each refetch drew another copy of it when that week was viewed.
			if (availabilitySource) {
				availabilitySource.remove();
			}

			availabilitySource = calendarInstance.addEventSource(
				events.map((t) => {
					const startTime = t.start || t.start_time_local;
					const endTime = t.end || t.end_time_local;
					const isAllDay = (startTime.startsWith("00:00") && (endTime.startsWith("24:00") || endTime.startsWith("00:00")));
					const isOneOff = t.recurrence_type === 'ONE_OFF' || !t.recurrence_type;

					const localStartDate = t.ranges[0].start.clone().local().format('YYYY-MM-DD');
					const localEndDate = t.ranges[0].end.clone().local().format('YYYY-MM-DD');

					const baseProps = {
						availabilityId: t.availability_id,
						availabilityGroupId: t.availability_group_id,
						title: t.custom_availability_name,
						allDay: isAllDay,
						...eventColours(t),
					};

					if (isOneOff) {
						return {
							...baseProps,
							start: isAllDay ? localStartDate : `${localStartDate}T${startTime}`,
							end: isAllDay ? localEndDate : `${localStartDate}T${endTime}`,
						};
					}

					// 2. Recurring Events
					const recurringEvent = {
						...baseProps,
						daysOfWeek: t.dow,
						startRecur: localStartDate,
					};

					// Do not attach startTime/endTime for all-day recurring events
					if (!isAllDay) {
						recurringEvent.startTime = startTime;
						recurringEvent.endTime = endTime;
					}

					return recurringEvent;
				})
			);
		});

		this.$onDestroy = function () {
			if (calendarInstance) {
				calendarInstance.destroy();
				calendarInstance = null;
			}
		};

		this.$postLink = function () {
			var Calendar = FullCalendar.Calendar;
			var Draggable = FullCalendarInteraction.Draggable;

			var containerEl = document.getElementById("draggable-area");
			var calendarEl = document.getElementById("calendar");

			// initialize the external events
			// -----------------------------------------------------------------

			new Draggable(containerEl, {
				itemSelector: ".fc-event",
				eventData: function (eventEl) {
					const obj = $scope.$ctrl.appointmentCategories.find((t) => t.category_id === eventEl.id);
					return {
						title: eventEl.innerText,
						color: eventEl.style.backgroundColor,
						duration: { minutes: obj?.duration ?? 120 },
					};
				},
			});

			// -----------------------------------------------------------------
			// initialize the calendar
			// -----------------------------------------------------------------

			calendarInstance = new Calendar(calendarEl, {
				plugins: ["interaction", "dayGrid", "timeGrid"],
				// The toolbar is drawn by the template, matching the appointment view's.
				header: false,
				defaultView: $scope.view.mode,
				defaultDate: $scope.$ctrl.startDate,
				minTime: "07:00:00",
				maxTime: "22:15:00",
				scrollTime: "08:00:00",
				nowIndicator: true,
				editable: true,
				droppable: true,
				// Click or drag across the calendar to add, as well as dragging in from the palette.
				selectable: true,
				selectMirror: true,
				eventLimit: 3,
				eventLimitText: "more",
				height: "parent",
				timeZone: "none",
				expandRows: true,
				allDaySlot: true, // Keep it visible so they can see existing leaves
				slotLabelFormat: { hour: "numeric", minute: "2-digit", meridiem: "short" },
				// Dates arrive UTC-coerced (timeZone "none"), so they are read back as UTC.
				columnHeaderHtml: function (date) {
					const day = moment.utc(date);
					if ($scope.view.mode === "dayGridMonth") {
						return `<span class="fc-col-weekday">${day.locale("en").format("ddd")}</span>`;
					}
					const isToday = day.format("YYYY-MM-DD") === moment().format("YYYY-MM-DD");
					return `<span class="fc-col-weekday">${day.locale("en").format("ddd")}</span>`
						+ `<span class="fc-col-date${isToday ? " is-today" : ""}">${day.format("D")}</span>`
						+ `<span class="fc-col-month">${day.locale("en").format("MMM")}</span>`;
				},

				// A timed selection stays within one day, as a time slot cannot cross midnight; whole days
				// can span several (leave).
				selectAllow: function (selectInfo) {
					if (selectInfo.allDay) {
						return true;
					}
					return moment.utc(selectInfo.start).format("YYYY-MM-DD")
						=== moment.utc(selectInfo.end).subtract(1, "seconds").format("YYYY-MM-DD");
				},
				select: function (info) {
					calendarInstance.unselect();
					$scope.$apply(function () {
						openCreateFromSelection(info);
					});
				},

				// 1. THE BOUNCER: Prevents the "ghost" drag and shows the forbidden cursor
				eventAllow: function (dropInfo, draggedEvent) {
					if (dropInfo.allDay) return false;

					if (dropInfo.start && dropInfo.end) {
						const startDay = moment.utc(dropInfo.start).format("YYYY-MM-DD");

						// Subtract 1 second in UTC to safely handle the midnight boundary
						const endDay = moment.utc(dropInfo.end).subtract(1, 'seconds').format("YYYY-MM-DD");

						if (startDay !== endDay) {
							return false;
						}
					}

					return true;
				},

				// 2. NEW DROPS: Handle external draggable items
				drop: function (info) {
					if (info.allDay) return; // Guard against external drops in all-day slot
					$scope.eventDrop(info);
				},

				// 3. MOVING EXISTING: Handle items already on the calendar
				eventDrop: function (info) {
					if (info.event.allDay) {
						info.revert();
						return;
					}
					updateEvent(info.event, info.revert, true);
				},

				// 4. CLEANUP: FullCalendar adds the event to the DOM on drop; 
				// we remove it immediately because our Modal/Refetch handles the "real" render.
				eventReceive: function (info) {
					info.event.remove();
				},

				// 5. OTHERS
				eventRender: $scope.eventRender,
				eventClick: $scope.eventClick,
				eventResize: function (info) {
					updateEvent(info.event, info.revert);
				},
				datesRender: function (info) {
					$scope.view.title = info.view.title;
					$scope.$applyAsync();
					$scope.$ctrl.changeDateRange({ start: moment(info.view.currentStart).format("YYYY-MM-DD") });
				},
			});

			calendarInstance.render();

			setTimeout(() => {
				if (calendarInstance) {
					calendarInstance.updateSize();
				}
			}, 250);
		};

		const getCategoryColor = (name) => {
			const target = ($scope.$ctrl.appointmentCategories || []).find((m) => m.name === name);
			if (target) {
				return "#" + target.colour;
			}
			return "red";
		};

		const isLeaveEntry = (t) => t.unavailable === "true" || t.unavailable === true || t.availability_type === "UNAVAILABLE";

		function hexToRgba(hex, alpha) {
			const match = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || "");
			if (!match) {
				return `rgba(91, 107, 140, ${alpha})`;
			}
			return `rgba(${parseInt(match[1], 16)}, ${parseInt(match[2], 16)}, ${parseInt(match[3], 16)}, ${alpha})`;
		}

		// Availability is drawn lighter than appointments - a tint of its type's colour with a solid edge -
		// so it reads as time on offer rather than time taken. Leave is red, striped by CSS.
		function eventColours(t) {
			const classNames = [isLeaveEntry(t) ? "avail-leave" : "avail-slot"];
			if (t.recurrence_type === "NUMBERED_WEEK" && parseInt(t.week_number_recurrence || 0, 10) > 0) {
				classNames.push("avail-repeats");
			}
			if (isLeaveEntry(t)) {
				return { classNames, backgroundColor: "#fdecea", borderColor: "#d9534f", textColor: "#a94442" };
			}
			const colour = getCategoryColor(t.custom_availability_name);
			const solid = colour === "red" ? "#5b6b8c" : colour;
			return { classNames, backgroundColor: hexToRgba(solid, 0.16), borderColor: solid, textColor: "#1f2a44" };
		}

		/* =================================================================== */
		/* Overview - the weekly pattern and what is coming up, in words
		/* =================================================================== */

		const WEEKDAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

		function isAllDayEntry(t) {
			const start = t.start || "";
			const end = t.end || "";
			return start.startsWith("00:00") && (end.startsWith("24:00") || end.startsWith("00:00"));
		}

		function formatClock(hhmmss) {
			return moment(hhmmss, "HH:mm:ss").locale("en").format("h:mm a");
		}

		function timeLabel(t) {
			return isAllDayEntry(t) ? "All day" : `${formatClock(t.start)} – ${formatClock(t.end)}`;
		}

		function frequencyLabel(weeks) {
			const n = parseInt(weeks || 0, 10);
			return n === 1 ? "Weekly" : `Every ${n} weeks`;
		}

		function dateRangeLabel(t) {
			const start = t.ranges[0].start.clone().local();
			if (!isAllDayEntry(t)) {
				return `${start.locale("en").format("ddd D MMM")}, ${timeLabel(t)}`;
			}
			// Whole-day leave ends at the start of the day after its last day.
			const lastDay = t.ranges[0].end.clone().local().subtract(1, "minute");
			if (!lastDay.isAfter(start, "day")) {
				return start.locale("en").format("ddd D MMM");
			}
			const sameMonth = lastDay.isSame(start, "month");
			return `${start.locale("en").format(sameMonth ? "ddd D" : "ddd D MMM")} – ${lastDay.locale("en").format("ddd D MMM")}`;
		}

		// The solid colour an entry is keyed by in the side panel.
		function entryColour(t) {
			if (isLeaveEntry(t)) {
				return "#d9534f";
			}
			const colour = getCategoryColor(t.custom_availability_name);
			return colour === "red" ? "#5b6b8c" : colour;
		}

		function buildOverview(available, unavailable) {
			const now = moment();
			const entries = [...available, ...unavailable].filter((t) => t.ranges && t.ranges[0]);
			const isRecurring = (t) => t.recurrence_type === "NUMBERED_WEEK" && parseInt(t.week_number_recurrence || 0, 10) > 0;

			$scope.pattern = entries
				.filter((t) => isRecurring(t) && (!t.end_date_utc || moment(t.end_date_utc).isAfter(now)))
				.map((t) => {
					const firstDate = t.ranges[0].start.clone().local();
					const day = t.dow && t.dow.length ? t.dow[0] : firstDate.day();
					return {
						id: t.availability_id,
						name: t.custom_availability_name,
						isLeave: isLeaveEntry(t),
						colour: entryColour(t),
						day: day,
						dayName: WEEKDAY_NAMES[day],
						sortKey: day * 10000 + (isAllDayEntry(t) ? 0 : parseInt((t.start || "0").replace(/:/g, "").slice(0, 4), 10)),
						time: timeLabel(t),
						frequency: frequencyLabel(t.week_number_recurrence),
						from: firstDate.isAfter(now) ? `from ${firstDate.locale("en").format("D MMM")}` : null,
						until: t.end_date_utc ? `until ${moment(t.end_date_utc).local().locale("en").format("D MMM")}` : null,
					};
				})
				.sort((a, b) => a.sortKey - b.sortKey);

			$scope.comingUp = entries
				.filter((t) => !isRecurring(t) && t.ranges[0].end.clone().local().isAfter(now))
				.sort((a, b) => a.ranges[0].start.valueOf() - b.ranges[0].start.valueOf())
				.slice(0, 8)
				.map((t) => ({
					id: t.availability_id,
					name: t.custom_availability_name,
					isLeave: isLeaveEntry(t),
					colour: entryColour(t),
					when: dateRangeLabel(t),
					date: t.ranges[0].start.clone().local().format("YYYY-MM-DD"),
				}));
		}
		$scope.pattern = [];
		$scope.comingUp = [];

		function trimTime(time) {
			if (!time) {
				return "";
			}

			if (!moment(time).isValid()) {
				return "";
			}

			let hours = time.getHours() < 10 ? `0${time.getHours()}` : time.getHours();
			let minutes = time.getMinutes() < 10 ? `0${time.getMinutes()}` : time.getMinutes();
			return `${hours}:${minutes}:00`;
		}

		const getOriginalEvent = (id) =>
			$scope.$ctrl.availableEvents.find((t) => t.availability_id === id) ??
			$scope.$ctrl.unavailableEvents.find((t) => t.availability_id === id);

		const getWeekday = (num) => ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"][num];

		const mapEventToPayload = (oldEvent, newEvent) => {
			let end = newEvent.end;
			const start = newEvent.start;

			const isLeave = oldEvent.availability_type === "UNAVAILABLE" || oldEvent.unavailable === "true" || oldEvent.unavailable === true;

			// Explicitly check if the new state is All Day
			const isActuallyAllDay = newEvent.allDay === true;

			let start_time_local = "";
			let end_time_local = "";
			let start_date_utc = "";

			// 1. RESOLVE START DATE & TIME
			if (isActuallyAllDay) {
				// Force All Day boundaries
				start_time_local = "00:00:00";
			} else if (typeof start === "string") {
				start_time_local = start;
			} else {
				// Edited via Drag/Drop (FullCalendar Date object)
				const localIsoString = start.toISOString().replace(".000Z", "");
				start_time_local = localIsoString.split("T")[1];
			}

			// Safely parse frequencies to avoid 'NaN' from stringified nulls
			const parseFreq = (val) => {
				if (!val || val === "null" || val === "undefined") return 0;
				const parsed = parseInt(val, 10);
				return isNaN(parsed) ? 0 : parsed;
			};

			const oldFreq = parseFreq(oldEvent.week_number_recurrence);
			const newFreq = parseFreq(newEvent.week_number_recurrence);

			// Accurately determine if the original event was a one-off
			const isOldOneOff = !oldEvent.recurrence_type || oldEvent.recurrence_type === "ONE_OFF" || oldFreq === 0;

			// Logic to determine the absolute start date (anchored locally to avoid NZDT shifts)
			if (typeof start === "string") {
				// Use the date clicked on the UI if available, fallback to original start
				const baseDateStr = newEvent.dateStr ? newEvent.dateStr.split("T")[0] : oldEvent.ranges[0].start.clone().local().format("YYYY-MM-DD");
				const localIsoString = `${baseDateStr}T${start_time_local}`;
				const proposedStartUtc = moment(localIsoString).utc().toISOString();
				const originalStartUtc = oldEvent.ranges[0].start.clone().utc().toISOString();

				if (newFreq === 0) {
					start_date_utc = proposedStartUtc;
				} else if (oldFreq !== newFreq && newFreq > 0) {
					// Re-anchor the series to the newly clicked date when frequency changes
					start_date_utc = proposedStartUtc;
				} else if (moment(localIsoString).isBefore(oldEvent.ranges[0].start)) {
					start_date_utc = proposedStartUtc;
				} else {
					start_date_utc = originalStartUtc;
				}
			} else {
				const localIsoString = start.toISOString().replace(".000Z", "");
				const proposedStartUtc = moment(localIsoString).utc().toISOString();
				const originalStartUtc = oldEvent.ranges[0].start.clone().utc().toISOString();

				if (newFreq === 0) {
					start_date_utc = proposedStartUtc;
				} else if (oldFreq !== newFreq && newFreq > 0) {
					// Re-anchor here as well for drag-and-drop frequency adjustments
					start_date_utc = proposedStartUtc;
				} else if (moment(localIsoString).isBefore(oldEvent.ranges[0].start)) {
					start_date_utc = proposedStartUtc;
				} else {
					start_date_utc = originalStartUtc;
				}
			}

			// 2. RESOLVE END TIME
			if (isActuallyAllDay) {
				end_time_local = "24:00:00";
			} else if (typeof end === "string") {
				end_time_local = end;
			} else if (end) {
				end_time_local = end.toISOString().replace(".000Z", "").split("T")[1];
			} else {
				end_time_local = oldEvent.end; // Fallback
			}

			// 4. UNAVAILABLE RANGE OVERRIDE (Date range bookings)
			if (newEvent.unavailableRange) {
				const { start_date_utc: uStart, end_date_utc: uEnd } = transformUnavailableRangeInPayload(newEvent.unavailableRange);

				// Multi-day recurring events are structurally impossible with the current DB schema. 
				// We MUST force Date Ranges to be ONE_OFF and preserve the multi-day end date.
				return {
					week_number_recurrence: null,
					custom_availability_name: newEvent.name ?? oldEvent.custom_availability_name,
					recurrence_type: "ONE_OFF",
					availability_type: isLeave ? "UNAVAILABLE" : "CUSTOM",
					start_time_local: "00:00:00",
					end_time_local: "24:00:00",
					day_recurrence: getWeekday(moment(uStart).day()),
					date_occurrence_utc: uStart,
					start_date_utc: uStart,
					end_date_utc: uEnd, // Keep the exact parsed end date!
					availability_group_id: newEvent.availabilityGroupId || (newEvent.extendedProps ? newEvent.extendedProps.availabilityGroupId : null),
					availability_id: oldEvent.availability_id,
					apply_to_all_user_practices: newEvent.applyToAllUserPractices
				};
			}

			// 5. DAY RECURRENCE logic
			const start_day = oldEvent.dow?.[0] ?? oldEvent.start;
			let _day_recurrence = getWeekday(start_day);
			if (!_day_recurrence) {
				_day_recurrence = getWeekday(moment(start_day).utc().day());
			}

			// 6. END DATE UTC
			let _end_date_utc = oldEvent.end_date_utc;

			if (newFreq > 0) {
				if (isOldOneOff) {
					// 1. Switching from single to recurring -> force clear the end date
					_end_date_utc = null;
				} else if (_end_date_utc) {
					// 2. It's ALREADY recurring, but check if it's holding onto a stuck/stale date
					const startUtc = moment(start_date_utc);
					const hardEnd = moment(_end_date_utc);
					const diffDays = hardEnd.diff(startUtc, "days");

					// Calculate minimum valid days before an event can be legitimately terminated via UI
					const minValidEndDiffDays = (newFreq * 7) - 2;

					// If the end date is shorter than the first recurrence interval, scrub it.
					if (diffDays >= 0 && diffDays < minValidEndDiffDays) {
						_end_date_utc = null;
					}
				}
			} else if (newFreq === 0) {
				// Changing to (or staying as) a ONE_OFF
				_end_date_utc = moment(start_date_utc).add(1, "day").utc().toISOString();
			}

			// 7. BUILD FINAL PAYLOAD
			const result = {
				week_number_recurrence: newEvent.week_number_recurrence ?? oldEvent.week_number_recurrence ?? 0,
				custom_availability_name: newEvent.name ?? oldEvent.custom_availability_name,
				recurrence_type: "NUMBERED_WEEK",
				availability_type: isLeave ? "UNAVAILABLE" : "CUSTOM",
				start_time_local,
				end_time_local,
				day_recurrence: typeof start === "string" ? _day_recurrence : getWeekday(moment(start).utc().day()),
				start_date_utc,
				date_occurrence_utc: start_date_utc,
				end_date_utc: _end_date_utc,
				availability_group_id: newEvent.extendedProps ? newEvent.extendedProps.availabilityGroupId : newEvent.availabilityGroupId,
				availability_id: oldEvent.availability_id,
				// Same as the date-range payload above, so a grouped edit reaches every practice.
				apply_to_all_user_practices: newEvent.applyToAllUserPractices,
			};

			// Clean up ONE_OFF flags
			if (parseInt(result.week_number_recurrence ?? 0) === 0) {
				result.week_number_recurrence = null;
				result.recurrence_type = 'ONE_OFF';
			} else if (parseInt(result.week_number_recurrence ?? 0) > 0 && !result.day_recurrence) {
				result.day_recurrence = getWeekday(moment(result.start_date_utc).day());
			}

			return result;
		};

		const transformUnavailableRangeInPayload = (unavailableRange) => {
			const array = unavailableRange.split(" - ");

			// Parse as LOCAL time first, then convert to UTC
			const formatStart = moment(array[0], "DD/MMM/YYYY").startOf('day');
			const formatEnd = moment(array[1], "DD/MMM/YYYY").startOf('day');

			return {
				start_date_utc: formatStart.utc().toISOString(),
				// Backend expects the end of the range to be the start of the next day
				end_date_utc: formatEnd.add(1, "day").utc().toISOString(),
			};
		};

		const addEvent = (event, isAvailable) => {
			$scope.AppointmentAPI.isProcessing = true;

			const isAllDay = event.allDay;
			// Safely grab just the YYYY-MM-DD from the calendar drop position
			const startDateStr = event.dateStr.split("T")[0];

			let data = {};

			// If it's Available, OR if it's an Hourly Leave (no date range)
			if (isAvailable || !event.unavailableRange) {
				const startTimeLocal = isAllDay ? "00:00:00" : event.startTime;
				const endTimeLocal = isAllDay ? "24:00:00" : event.endTime;

				// 1. Stitch the date and the (potentially edited) time together
				const localIsoString = `${startDateStr}T${startTimeLocal}`;

				// 2. Let Moment parse it in local time, then convert to strict UTC
				let start_date_utc = moment(localIsoString).utc().toISOString();

				data = {
					custom_availability_name: event.name,
					recurrence_type: "NUMBERED_WEEK",
					availability_type: isAvailable ? "CUSTOM" : "UNAVAILABLE",
					start_time_local: startTimeLocal,
					end_time_local: endTimeLocal,
					start_date_utc: start_date_utc,
					date_occurrence_utc: start_date_utc,
					day_recurrence: getWeekday(moment(localIsoString).day()),
					week_number_recurrence: event.week_number_recurrence ?? 0,
				};

				// 3. Handle ONE_OFF safety
				if (parseInt(data.week_number_recurrence, 10) === 0) {
					// If it's a Time Slot (Hourly), the end_date_utc should actually be 
					// the same day as the start. If All Day, it needs the +1 day buffer.
					data.end_date_utc = isAllDay
						? moment(start_date_utc).add(1, "day").utc().toISOString()
						: moment(start_date_utc).endOf('day').utc().toISOString(); // End of the same UTC day

					data.week_number_recurrence = null;
					data.recurrence_type = 'ONE_OFF';
					data.day_recurrence = null;
				}

			} else {
				// It's a Multi-Day Leave (Date Range)
				const { start_date_utc, end_date_utc } = transformUnavailableRangeInPayload(event.unavailableRange);

				// Because the backend uses end_date_utc for both duration and recurrence termination,
				// multi-day recurring events are impossible. We safely force all Date Ranges to ONE_OFF.
				data = {
					availability_type: "UNAVAILABLE",
					recurrence_type: "ONE_OFF",
					week_number_recurrence: null,
					day_recurrence: getWeekday(moment(start_date_utc).day()),
					custom_availability_name: event.name,
					start_time_local: "00:00:00", // Ranges are always all day
					end_time_local: "24:00:00",
					start_date_utc: start_date_utc,
					date_occurrence_utc: start_date_utc,
					end_date_utc: end_date_utc, // Keep the exact parsed multi-day end date!
				};
			}

			let applyToAll = event.applyToAllUserPractices ?? false;

			$scope.AppointmentAPI.addPracticeAvailability($scope.$ctrl.practiceId, $scope.$ctrl.userId, data, applyToAll)
				.then(
					function () {
						$scope.$ctrl.refetch({ practiceId: $scope.$ctrl.practiceId });
					},
					function () {
						$scope.serverErrorModal = $modal({
							scope: $scope,
							templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
							show: true,
							title: "CatTrax has encountered an error",
						});
					},
				)
				.then(() => {
					$scope.AppointmentAPI.isProcessing = false;
					$scope.closeDetailsModal();
				});
		};

		const updateEvent = (event, revert, isFromEventDrop = false) => {
			// Safely grab the ID from extendedProps if it exists
			const availabilityId = event.extendedProps ? event.extendedProps.availabilityId : event.availabilityId;
			const original = getOriginalEvent(availabilityId);

			if (!original) {
				revert();
				return;
			}

			// Safely check for Leave across different object shapes
			const isLeave = original.availability_type === "UNAVAILABLE" || original.unavailable === "true" || original.unavailable === true;

			if (isFromEventDrop && isLeave && !original.week_number_recurrence) {
				// Only block moving if it is actually a Full-Day or Multi-Day Date Range!
				if (original.start === "00:00:00" && original.end === "24:00:00") {
					revert();
					return;
				}
			}

			$scope.AppointmentAPI.isProcessing = true;

			const data = mapEventToPayload(original, event);

			$scope.AppointmentAPI.updatePracticeAvailability($scope.$ctrl.practiceId, $scope.$ctrl.userId, availabilityId, data)
				.then(
					function () {
						$scope.$ctrl.refetch({ practiceId: $scope.$ctrl.practiceId });
					},
					function () {
						revert();
						$scope.serverErrorModal = $modal({
							scope: $scope,
							templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
							show: true,
							title: "CatTrax has encountered an error",
						});
					},
				)
				.then(() => {
					$scope.AppointmentAPI.isProcessing = false;
					$scope.closeDetailsModal();
				});
		};

		const deleteEvent = (event, revert) => {
			const availabilityId = event.availabilityId;
			$scope.AppointmentAPI.isProcessing = true;
			$scope.AppointmentAPI.deletePracticeAvailability($scope.$ctrl.practiceId, $scope.$ctrl.userId, availabilityId)
				.then(
					function () {
						$scope.$ctrl.refetch({ practiceId: $scope.$ctrl.practiceId });
					},
					function () {
						revert();
						$scope.serverErrorModal = $modal({
							scope: $scope,
							templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
							show: true,
							title: "CatTrax has encountered an error",
						});
					},
				)
				.then(() => {
					$scope.AppointmentAPI.isProcessing = false;
					$scope.closeDetailsModal();
				});
		};

		$scope.closeDetailsModal = function () {
			if ($scope.detailsModal) {
				$scope.detailsModal.hide();
			}
		};

		$scope.frequencyOptions = [
			{ name: "Only once", value: '0' },
			{ name: "Every one week", value: '1' },
			{ name: "Every two weeks", value: '2' },
			{ name: "Every three weeks", value: '3' },
			{ name: "Every four weeks", value: '4' },
		];

		$scope.saveAvailability = function (validation) {
			if (!validation) return;

			// FORCE applyToAll if it's already part of a group
			const isAlreadyGrouped = !!$scope.availability.availability_group_id;
			const applyToAll = isAlreadyGrouped || !!$scope.availability.applyToAllUserPractices;

			if (!$scope.availability.name) {
				$scope.availability.name = 'Leave';
			}

			const info = {
				dateStr: $scope.availability.dateStr,
				startTime: trimTime($scope.availability.start_time),
				endTime: trimTime($scope.availability.end_time),
				name: $scope.availability.name,
				allDay: $scope.availability.isAllDay,
				week_number_recurrence: $scope.availability.week_number_recurrence,
				_isDateRange: !!$scope.isDateRange.value,
				unavailableRange: $scope.isDateRange.value ? $scope.availability.unavailableRange : null,
				applyToAllUserPractices: applyToAll,
			};

			if ($scope.availability.availabilityId) {
				updateEvent({
					...info,
					availabilityId: $scope.availability.availabilityId,
					availabilityGroupId: $scope.availability.availability_group_id,
					start: $scope.availability.isAllDay ? "00:00:00" : info.startTime,
					end: $scope.availability.isAllDay ? "24:00:00" : info.endTime,
				}, () => void 0);
				return;
			}

			addEvent(info, $scope.availability.isAvailable);
		};

		const convertTimeToDateObj = (strTime) => {
			const array = strTime.split(":");
			const result = new Date();
			result.setHours(Number(array[0]), Number(array[1]), 0, 0);
			return result;
		};

		// End of a new slot, kept on the same day: a slot dropped late in the evening would otherwise
		// end at "24:xx" (next-day midnight) and fail the start/end validation.
		const defaultEndTime = (startArray, minutes) => {
			const start = moment().hour(Number(startArray[0])).minute(Number(startArray[1])).second(0);
			const end = start.clone().add(minutes, "minutes");
			return end.isSame(start, "day") ? end.format("HH:mm:ss") : "23:59:00";
		};

		$scope.deleteCalendarEvent = (availabilityId, revert, applyToAllUserPractices) => {
			const fun = revert ?? (() => void 0);
			deleteEvent({ availabilityId, applyToAllUserPractices }, fun);
		};

		/* =================================================================== */
		/* Opening the editor
		/* =================================================================== */

		function showEditor() {
			$scope.detailsModal = $modal({
				scope: $scope,
				controller: "ModalCtrl",
				templateUrl: "app/src/views/templates/modal.availability-detail.tpl.html",
				show: true,
				backdrop: "static",
			});
		}

		function categoryNames() {
			return ($scope.$ctrl.appointmentCategories || []).map((c) => c.name);
		}

		function rangeText(firstDate, lastDate) {
			return `${moment(firstDate).locale("en").format("DD/MMM/YYYY")} - ${moment(lastDate || firstDate).locale("en").format("DD/MMM/YYYY")}`;
		}

		/**
		 * Opens the editor on an existing entry. `fcEvent` is the occurrence clicked on the calendar, when
		 * there was one - "only this one" and "this and following" are measured from it, so they are not
		 * offered when an entry is opened from the side panel.
		 */
		function openEdit(availabilityId, fcEvent) {
			const event = getOriginalEvent(availabilityId);

			// Safety check to prevent crashes if the event isn't found
			if (!event) return;

			const checkAllDay = (event.start.startsWith("00:00") &&
				(event.end.startsWith("24:00") || event.end.startsWith("00:00")));

			$scope.availability = {
				availabilityId: availabilityId,
				availabilityGroupId: event.availability_group_id,
				start_time: convertTimeToDateObj(event.start),
				end_time: convertTimeToDateObj(event.end),
				isAllDay: checkAllDay,
				name: event.custom_availability_name,
				week_number_recurrence: (!event.week_number_recurrence || event.recurrence_type === 'ONE_OFF') ? '0' : String(event.week_number_recurrence),
				isAvailable: event.unavailable === "false",
				recurrence_type: event.recurrence_type,
				ranges: event.ranges,
				applyToAllUserPractices: event.apply_to_all_user_practices === true || event.apply_to_all_user_practices === "true"
			};
			$scope.clickedEvent = fcEvent || null;
			resetDeleteState();
			refreshSessionTypes();
			showEditor();
		}

		$scope.openEditById = function (availabilityId) {
			openEdit(availabilityId, null);
		};

		/**
		 * Opens the editor on something new. `opts`: date (YYYY-MM-DD); startTime and endTime (HH:mm:ss),
		 * left out for whole days; lastDate for a run of whole days; isAvailable; name.
		 */
		function openCreate(opts) {
			const allDay = !opts.startTime;
			$scope.availability = {
				isAvailable: opts.isAvailable,
				isAllDay: allDay,
				dateStr: allDay ? opts.date : `${opts.date}T${opts.startTime}`,
				rangeEndStr: opts.lastDate || null,
				name: opts.name,
				week_number_recurrence: $scope.frequencyOptions[0].value,
			};
			if (allDay && opts.isAvailable) {
				$scope.availability.start_time = "00:00";
				$scope.availability.end_time = "24:00";
			} else if (!allDay) {
				$scope.availability.start_time = convertTimeToDateObj(opts.startTime);
				$scope.availability.end_time = convertTimeToDateObj(opts.endTime);
			}
			if (!opts.isAvailable && allDay) {
				// Whole days of leave are a date range, written as the range picker writes it.
				$scope.availability.unavailableRange = rangeText(opts.date, opts.lastDate);
			}
			$scope.clickedEvent = null;
			resetDeleteState();
			refreshSessionTypes();
			showEditor();
		}

		// Clicked or dragged across the calendar. Whole days default to leave - that is what whole days
		// are usually marked for - and times to an available session of the first appointment type.
		function openCreateFromSelection(info) {
			// UTC-coerced (timeZone "none"), so the ISO string is the wall time.
			const start = info.start.toISOString().slice(0, 19);
			const end = info.end.toISOString().slice(0, 19);
			if (info.allDay) {
				openCreate({
					date: start.slice(0, 10),
					lastDate: moment.utc(info.end).subtract(1, "day").format("YYYY-MM-DD"),
					isAvailable: false,
				});
				return;
			}
			openCreate({
				date: start.slice(0, 10),
				startTime: start.slice(11),
				endTime: end.slice(0, 10) === start.slice(0, 10) ? end.slice(11) : "23:59:00",
				isAvailable: true,
				name: categoryNames()[0],
			});
		}

		$scope.eventClick = function (info) {
			const fcAvailabilityId = info.event.extendedProps ? info.event.extendedProps.availabilityId : info.event.availabilityId;
			$scope.$evalAsync(function () {
				openEdit(fcAvailabilityId, info.event);
			});
		};

		// Dropped in from the palette. All-day drops are refused - the palette's items are timed.
		$scope.eventDrop = function (info) {
			if (info.allDay || info.dateStr.indexOf("T") === -1) {
				return;
			}
			const isLeave = info.draggedEl.id === "unavailable";
			const date = info.dateStr.split("T")[0];
			const startTime = info.dateStr.split("T")[1];
			const targetCategory = isLeave ? null : $scope.$ctrl.appointmentCategories.find((t) => t.category_id === info.draggedEl.id);
			const endTime = defaultEndTime(startTime.split(":"), targetCategory ? targetCategory.duration : 120); //default duration is 2 hours

			$scope.$evalAsync(function () {
				openCreate({
					date: date,
					startTime: startTime,
					endTime: endTime,
					isAvailable: !isLeave,
					name: isLeave ? undefined : (info.draggedEl.getAttribute("data-name") || info.draggedEl.innerText.trim()),
				});
			});
		};

		/* =================================================================== */
		/* Editor helpers
		/* =================================================================== */

		// Available or unavailable - chosen in the editor for anything new.
		$scope.setKind = function (isAvailable) {
			const a = $scope.availability;
			if (a.isAvailable === isAvailable) {
				return;
			}
			a.isAvailable = isAvailable;
			if (isAvailable) {
				$scope.isDateRange.value = false;
				if (!a.name || !categoryNames().includes(a.name)) {
					a.name = categoryNames()[0];
				}
				refreshSessionTypes();
				return;
			}
			if (categoryNames().includes(a.name)) {
				a.name = "";
			}
			if (a.isAllDay) {
				a.unavailableRange = a.unavailableRange || rangeText(a.dateStr.split("T")[0], a.rangeEndStr);
				$scope.isDateRange.value = true;
			}
		};

		// The session types offered, with their colours: the appointment types, plus the entry's own name
		// when it is not one of them (older entries). Built once per opening - the dropdown watches the
		// list, so it cannot be a fresh array on every digest.
		$scope.sessionTypes = [];
		function refreshSessionTypes() {
			const types = ($scope.$ctrl.appointmentCategories || []).map((c) => ({ name: c.name, colour: "#" + c.colour }));
			const current = $scope.availability && $scope.availability.isAvailable && $scope.availability.name;
			if (current && !types.some((t) => t.name === current)) {
				types.push({ name: current, colour: "#5b6b8c" });
			}
			$scope.sessionTypes = types;
		}

		/** One line saying exactly what will be saved, kept up to date as the form changes. */
		$scope.describeAvailability = function () {
			const a = $scope.availability;
			if (!a) {
				return "";
			}
			const what = a.isAvailable
				? `Open for ${a.name || "appointments"}`
				: (a.name && a.name !== "Leave" ? `Unavailable (${a.name})` : "Unavailable");

			if (!a.isAvailable && $scope.isDateRange.value) {
				return a.unavailableRange ? `${what} · ${a.unavailableRange.replace(" - ", " to ")}` : what;
			}

			const base = a.dateStr
				? moment(a.dateStr.split("T")[0])
				: (a.ranges && a.ranges[0] ? a.ranges[0].start.clone().local() : null);
			const time = a.isAllDay
				? "all day"
				: (a.start_time instanceof Date && a.end_time instanceof Date
					? `${moment(a.start_time).locale("en").format("h:mm a")} – ${moment(a.end_time).locale("en").format("h:mm a")}`
					: "");
			const weeks = parseInt(a.week_number_recurrence || 0, 10);
			let when = "";
			if (base && weeks === 0) {
				when = base.locale("en").format("dddd D MMMM");
			} else if (base) {
				when = `${weeks === 1 ? "every" : `every ${weeks} weeks on`} ${base.locale("en").format("dddd")}`;
				if (base.isAfter(moment(), "day")) {
					when += ` from ${base.locale("en").format("D MMM")}`;
				}
			}
			return [what, when, time].filter(Boolean).join(" · ");
		};

		/* =================================================================== */
		/* Deleting - asked in place, in the editor's action bar
		/* =================================================================== */

		function resetDeleteState() {
			$scope.deleteState.open = false;
			$scope.deleteState.mode = "all";
			$scope.deleteState.options = [];
		}

		// Whether there is a series to choose within - the test the separate confirmation used to make.
		function isRecurrenceEntry(originalEvent) {
			const freq = parseInt(originalEvent.week_number_recurrence || 0, 10);
			const isLeave = originalEvent.availability_type === "UNAVAILABLE" ||
				originalEvent.unavailable === "true" ||
				originalEvent.unavailable === true;

			if (freq === 1 && isLeave && originalEvent.ranges && originalEvent.ranges.length > 0) {
				const start = originalEvent.ranges[0].start;
				const end = originalEvent.ranges[0].end;
				return moment(end).diff(moment(start), "hours") > 24;
			}
			return !(freq === 0 || originalEvent.recurrence_type === 'ONE_OFF');
		}

		$scope.startDelete = function () {
			const original = getOriginalEvent($scope.availability.availabilityId);
			if (!original) return;
			const options = [];
			if (isRecurrenceEntry(original)) {
				if ($scope.clickedEvent) {
					options.push({ value: "this", label: "Only this one" }, { value: "following", label: "This and following" });
				}
				options.push({ value: "all", label: "Every one" });
			}
			$scope.deleteState.options = options;
			// The narrowest choice first, so a hurried click removes as little as possible.
			$scope.deleteState.mode = options.length ? options[0].value : "all";
			$scope.deleteState.open = true;
		};

		$scope.confirmDelete = function () {
			const availabilityId = $scope.availability.availabilityId;
			const original = getOriginalEvent(availabilityId);
			if (!original) return;
			const applyToAll = original.apply_to_all_user_practices === true || original.apply_to_all_user_practices === "true";

			if ($scope.deleteState.mode === "this") {
				$scope.deleteEventInSeries(availabilityId, $scope.clickedEvent.start, true, applyToAll);
			} else if ($scope.deleteState.mode === "following") {
				$scope.deleteEventInSeries(availabilityId, $scope.clickedEvent.start, false, applyToAll);
			} else {
				$scope.deleteCalendarEvent(availabilityId, null, applyToAll);
			}
		};

		// A repeat mark, and a plain description on hover.
		function decorateEvent(info, originalEvent) {
			const el = info.el;
			const repeats = el.classList.contains("avail-repeats");
			el.setAttribute("title", `${originalEvent.custom_availability_name || ""} · ${timeLabel(originalEvent)}`
				+ (repeats ? ` · ${frequencyLabel(originalEvent.week_number_recurrence)}` : ""));
			if (repeats) {
				const target = el.querySelector(".fc-title") || el.querySelector(".fc-content");
				if (target && !target.querySelector(".avail-repeat-icon")) {
					const icon = document.createElement("i");
					icon.className = "fa fa-repeat avail-repeat-icon";
					target.appendChild(icon);
				}
			}
		}

		$scope.eventRender = function (info) {
			const event = info.event;
			const originalEvent = getOriginalEvent(event.extendedProps?.availabilityId || event.availabilityId);

			if (!originalEvent) return false;

			// 1. Skip checks for One-Offs - trust the addEventSource mapping
			if (originalEvent.recurrence_type === 'ONE_OFF' || !originalEvent.recurrence_type) {
				decorateEvent(info, originalEvent);
				return true;
			}

			// 2. Recurrence Frequency logic (only for recurring)
			const frequency = parseInt(originalEvent.week_number_recurrence);
			if (frequency > 1) {
				const startOfRecurrence = originalEvent.ranges[0].start.clone().local().startOf('day');
				const currentEventStart = moment(event.start).local().startOf('day');
				const weeksDiff = currentEventStart.diff(startOfRecurrence, 'weeks');

				if (weeksDiff % frequency !== 0) return false;
			}

			// 3. Check hard end dates for recurring series
			if (originalEvent.end_date_utc && moment(originalEvent.end_date_utc).isBefore(moment(event.start))) {
				return false;
			}

			// 4. Exception Dates (Local check)
			const isExcluded = (originalEvent.exception_dates || []).some(ex =>
				moment(ex.exception_date_utc).local().isSame(moment(event.start), 'day')
			);

			if (isExcluded) {
				return false;
			}
			decorateEvent(info, originalEvent);
			return true;
		};

		/**
		 * availabilityId
		 * exceptionDate
		 * true: only delete this; false: delete following
		 */
		$scope.deleteEventInSeries = (availabilityId, exceptionDate, isSingle, applyToAllUserPractices) => {
			const original = getOriginalEvent(availabilityId);
			if (!original) {
				return;
			}
			const restProps = {};
			if (isSingle) {
				restProps.exception_dates = [...(original.exception_dates || []), { exception_date_utc: exceptionDate.toISOString() }];
				restProps.end_date_utc = original.end_date_utc;
			} else {
				restProps.end_date_utc = moment(exceptionDate).subtract(1, "days").endOf("day").toISOString();
				restProps.exception_dates = original.exception_dates || [];
			}
			$scope.AppointmentAPI.isProcessing = true;
			const data = {
				week_number_recurrence: original.week_number_recurrence,
				custom_availability_name: original.custom_availability_name,
				recurrence_type: original.recurrence_type,
				availability_type: original.unavailable === "false" ? "CUSTOM" : "UNAVAILABLE",
				start_time_local: original.start,
				end_time_local: original.end,
				day_recurrence: original.dow ? getWeekday(original.dow[0]) : getWeekday(moment(original.start).day()),
				start_date_utc: original.ranges[0].start.toDate().toISOString(),
				apply_to_all_user_practices: applyToAllUserPractices,
				...restProps,
			};
			$scope.AppointmentAPI.updatePracticeAvailability($scope.$ctrl.practiceId, $scope.$ctrl.userId, availabilityId, data)
				.then(
					function () {
						$scope.$ctrl.refetch({ practiceId: $scope.$ctrl.practiceId });
					},
					function () {
						$scope.serverErrorModal = $modal({
							scope: $scope,
							templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
							show: true,
							title: "CatTrax has encountered an error",
						});
					},
				)
				.then(() => {
					$scope.AppointmentAPI.isProcessing = false;
					$scope.closeDetailsModal();
				});
		};
	},
]);
